/**
 * Created by rupesh.mishra on 05-01-2017.
 */
//Global variables
// alert('main grid');
var contextMenuAllowedCuts = ['nmv','std','sch','sar'],
    contextMenuAllowedSource = ['period','source'],
    contextMenuAllowedPeriod = ['current', '', 'consensus', 'currentconsensus'],
    // contextMenuRestrictedSource = ['custom'],
    contextMenuAllowedGrowthType = ['analytics'],
    contextMenuDiv = $('#chart-context-menu'),
    isCompsPage,
    compsContextData;


var setInterValIdFormulaBar;
var cPlusConst = ['Consensus+','consensus+','consensusplus'];
//Turning the click off and on since there is a generic kind of implementation since the 3 existing options where all charts

function auditClicked() {
    setInterValIdFormulaBar = setTimeout(function () {
        const openFBar = new CustomEvent('openFBar', {detail:{} })
        window.dispatchEvent(openFBar); 

    }, 500)
}


var ev = null;
function recomputeContextPositionHandler() {
    if (ev !== null) {
        computeContextMenuHeight(ev);
    }
    ev = null;
}
window.removeEventListener("recomputeContextPosition",recomputeContextPositionHandler);
window.addEventListener("recomputeContextPosition", recomputeContextPositionHandler);


// $('.context-menu-audit').off('click', auditClicked).on('click', auditClicked)
// $('.context-menu-vaexcel').off('click', copyExcelAddin).on('click', copyExcelAddin);


//Displays the context menu on right click
//contextElement - Current clicked grid element
function showContextMenu(event, isComps, compsData) {
    ev = event;
    isCompsPage = isComps;
    contextMenuDiv = $('.mex-context-menu');
    var $target = $(event.currentTarget);
    
    event.preventDefault();
    $(window).trigger('bindMexContextMenu', { target: $target, contextMenuDiv: contextMenuDiv });
    if(MEData.view_code == 'SCH'){
        contextMenuDiv.attr('dapparam_id',$target.attr('id'));
    }
    contextMenuDiv.attr('id',$target.attr('id'));
    /** CACHE-2684: Added setTimeout as context menu takes time to load 
     * due to this some options were missing 
     * for some cases for row wise data for last line in the grid.
     */
    setTimeout(() => {
        computeContextMenuHeight(event);
        // $('.context-menu-audit').off('click', auditClicked).on('click', auditClicked);
    }, 0);
    contextMenuDiv.attr('period',$target.attr('period'));
    contextMenuDiv.attr('dapparam_id',$target.attr('dapparam_id'));
    contextMenuDiv.attr('source',$target.attr('source'));
    contextMenuDiv.attr('forecast',$target.attr('forecast'));
    contextMenuDiv.attr('field',$target.attr('field'));
    contextMenuDiv.attr('revision',$target.attr('revision'));
    contextMenuDiv.attr('iscomparetopeer',$target.attr('iscomparetopeer'));
    contextMenuDiv.attr('lineItemName',$target.attr('lineItemName'));
    contextMenuDiv.attr('lineItemCode',$target.attr('lineItemCode'));
}

function computeContextMenuHeight(event) {
    var headerHeight = $(window).height() - ($(".content-section").height());
    var leftSideBarWidth = $(".leftSider").width();
    var gridHolderWidth = $(".grid-holder").width();
    var gridHolderHeight = $(".grid-holder").height();
    let top = (gridHolderHeight > (event.clientY - headerHeight) + contextMenuDiv.height() ) 
        ? event.clientY - headerHeight
        : (event.clientY - headerHeight) - contextMenuDiv.height();
    if(top < 0) {
    top = 0;
    }
    const left = (gridHolderWidth > (event.clientX - leftSideBarWidth) + contextMenuDiv.width() ) 
        ? event.clientX - leftSideBarWidth 
        : (event.clientX - leftSideBarWidth) - contextMenuDiv.width();
    contextMenuDiv.show();
    contextMenuDiv.removeClass("context-menu").addClass("context-menu-active");
    contextMenuDiv.css('top', top);
    contextMenuDiv.css('left', left);
}

//Adds the event listener on the document to close the context menu on click of anywhere on the
//document apart from the grid
function hideCustomContextMenu() {
    $(contextMenuDiv).webuiPopover('destroy')
    $(document).off('click.contextmenu').on('click.contextmenu', function(event) {
        if (!$(event.target).closest('.datasettable').length) {
            contextMenuDiv.addClass('context-menu');
            contextMenuDiv.hide();
        }
    })
     contextMenuDiv.hide();
}

//Binds the context menu event to the bindingElement passed
function bindContextMenuEvent(bindingElement, cut, source, revisionPeriod, rowData) {
    source = (source === undefined) ? '': source;
    revisionPeriod = (revisionPeriod === undefined) ? '' : revisionPeriod.toLowerCase();
    
    var checkSource = source.match(/(consensusplus)/gi) || source.match(/(consensus\+)/gi);
    if(!checkSource || checkSource.length === 0) {
        checkSource = source.match(/(consensus)/gi);
    }
    if(checkSource && checkSource.length > 0){
        // source = (source && (source.toLowerCase() == "consensusplus" || source.toLowerCase() == "consensus+")) ? 'Consensus+': 'Consensus';
        // @todo figureout regex
        source = cPlusConst.includes(checkSource[0].toLowerCase()) ? 'Consensus+': 'Consensus';
    }


    // blank check needed for row source expansions
    if(revisionPeriod === ''){
        revisionPeriod = source;
    }
    //In case of revision applied
    checkSource = source.match(/(current)/gi);
    if(checkSource && checkSource.length > 0){
         source = source.split('current')[1];
    }
    bindingElement.attr('source', source);
    bindingElement.attr('id', $(bindingElement).attr('id'));
    checkSource = (source === undefined) ? '' : source.match(/(custom)/gi);//add values to regex as and when needed to manage the source checks
    var revision = revisionPeriod.split(source)[0];
    var checkRevision = (revision === undefined) ? '' : revision.match(/(current)/gi);
    if (bindingElement.text() == '' || (checkSource && checkSource.length != 0) || (source && source.toLowerCase() != revisionPeriod && !checkRevision)) {
        //return;
    }
    if(checkSource && checkSource.length != 0 && checkSource[0].toLowerCase() === 'custom'){
         source = 'custom';
    }
    //if(contextMenuDiv.length==0){
        contextMenuDiv = $('.mex-context-menu');
    //}
    hideCustomContextMenu();
    if (($.inArray(cut.toLowerCase(), contextMenuAllowedCuts) !== -1)) {
        bindingElement.contextmenu(function (event) {
            //Trigger grid cell click event
            bindingElement.trigger('click');
            if(bindingElement.attr('id') != "") {
            showContextMenu(event,false, null, contextMenuDiv);
            }
        })
    }
    return source
}
